import { useRef } from 'react';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { Trans } from '@lingui/react/macro';


function FocusModal({device, close, dismiss}) {
  const interval = useRef(60);

  async function finish() {
    close(interval.current);
  }

  return (
    <I18nProvider i18n={i18n}>
      <header>
        <h3><Trans>Enable Focus Mode for</Trans>: <strong>{device.model.name}</strong></h3>
      </header>
      <section>
        <p>
          <Trans>Enabling Focus Mode will continually request readings updates until you navigate away from this circuit.</Trans>
        </p>
        <ul className="form">
          <li>
              <Trans>Request readings every</Trans>&nbsp;
              <input
                type="number"
                id="focus-interval"
                defaultValue={interval.current}
                style={{width: 60}}
                onChange={event => interval.current = event.target.value}
              />
              &nbsp;<Trans>seconds</Trans>
          </li>
        </ul>
      </section>
      <footer>
        <button onClick={dismiss}>
          <Trans>Cancel</Trans>
        </button>
        <button
          className={`primary`}
          onClick={finish}
        >
          <Trans>Enable</Trans>
        </button>
      </footer>
    </I18nProvider>
  )
}

export default FocusModal;
